export default "__VITE_ASSET__BrcxLHTN__"